import React, { useState, useEffect } from "react";
import { Table, Spinner } from "react-bootstrap";

const TableData = ({ timezone }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (timezone && timezone.length > 0) {
      setLoading(false);
    }
  }, [timezone]);

  return (
    <>
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "100px" }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Table responsive className="commonTable">
          <thead>
            <tr>
              <th className="fw-normal border-0">Name</th>
              <th className="fw-normal border-0">City</th>
              <th className="fw-normal border-0">Country</th>
              <th className="fw-normal border-0">Offset</th>
              <th className="fw-normal border-0">Status</th>
            </tr>
          </thead>
          <tbody>
            {timezone.map((data, key) => (
              <tr key={key}>
                <td>{data?.name ? data?.name : "-"}</td>
                <td>{data?.city ? data?.city : "-"}</td>
                <td>{data?.country ? data?.country : "-"}</td>
                <td>{data?.offset ? data?.offset : "-"}</td>
                <td className="text-capitalize">
                  <span className="labelTag greenLabel">
                    {data?.status ? data?.status : "-"}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default TableData;
